// ----------------------------------------------------------------------------
// Component: Isotope Filtering
// ----------------------------------------------------------------------------
//
// Some JS to handle filter states
//
// ----------------------------------------------------------------------------

var $       = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _       = require('lodash');
var Isotope = require('isotope-layout');

// Isotope Variables
var ISOTOPE_LAYOUT      = '.isotope-layout';
var GRID                = '.masonry-grid';
var FILTER_BUTTONS      = '.isotope-layout__filters .button';
var FILTER_SELECTS      = '.isotope-layout__filters select';
var SORTING             = '.isotope-layout__sorting select';
var activeFilters       = {}; // Active Filter State
var gridBlock           = '.masonry-grid__block:visible';
var emptyText           = '.isotope-layout__notfound';


// Custom Select Dropdown Variables
var body               = 'html, body';
var label              = '.isotope-layout__label-placeholder';
var select_set         = '.isotope-layout__select-set';
var select_wrapper     = '.isotope-layout__select';
var selectbox_options  = '.isotope-layout__options';
var selectbox_selector = '.isotope-layout__filters select';


module.exports = function() {

    // Find all valid Isotope implementations
    $(ISOTOPE_LAYOUT).each(function() {

        // Initalize Isotope
        var grid                 = this.querySelector(GRID);
        var dataOptions          = JSON.parse(grid.getAttribute('data-isotope-layout'));
        var sortKeys             = [];
        var sortData             = {};

        // Prepare Custom Sorting
        var $sorting             = $(this).find(SORTING);
        var $filterButtons       = $(this).find(FILTER_BUTTONS);
        var $filterSelects       = $(this).find(FILTER_SELECTS);
        var $filterShowAllButton = $filterButtons.filter('[data-filter="\*"]');
        var filterTypesObj       = {};
        var filterTypes          = [];

        // Prepare Isotope Object
        var $isotope             = null;


        // Copy Masonry Data Options to the 'masonry' attribute
        // This is needed due to masonry and isotope having slightly different option structures
        dataOptions['masonry'] = jQuery.extend({}, dataOptions);

        // Get the Keys to Sort by
        sortKeys = $sorting.find('option').map(function(){
            return this.value ? this.value : null;
        }).get();

        // Prepare Sorting Properties for Isotope
        $.each(sortKeys, function(index, sortKey) {
            sortData[sortKey] = function(itemElem) {
                return sortFunction(sortKey, itemElem);
            };
        });
        dataOptions['getSortData'] = sortData;


        // Get Available Filter Types (from buttons)
        $filterButtons.filter('[data-filter!="\*"]').each(function() {
            var $filterData = $(this).data('filter');

            $.each($filterData, function(filterType, filterValue) {
                filterTypesObj[filterType] = true;
            });
        });

        // Get Available Filter Types (from selects)
        $filterSelects.each(function() {
            var filterType = $(this).data('filter-type');

            filterTypesObj[filterType] = true;
        });


        // Define Available Filter Types
        filterTypes = $.map(filterTypesObj, function(element, filterType) {
            return filterType;
        });


        // Null the initial filter state to "show all" only (for buttons)
        $filterButtons.filter('[data-filter]').each(function() {
            var $filterData   = $(this).data('filter');

            $(this).toggleClass('is-checked', ($filterData == '*'));
        });

        // Null the initial filter state to "show all" only (for selects)
        $filterSelects.each(function() {
            $(this).find('option').prop('selected', false);
            $(this).find('option[value="\*"]').prop('selected', true);
        });


        // Set filter initial state to match the URL hash
        $.each(filterTypes, function(index, filterType) {
            var filterHashValue = getHashValue(filterType);

            if (filterHashValue) {
                filterValues = filterHashValue.split(':');

                $filterButtons.filter('[data-filter!="\*"]').each(function() {
                    var $filterData          = $(this).data('filter');
                    var $filterButton        = $(this);

                    $.each($filterData, function(filterType, filterValue) {
                        if (filterValues.indexOf(filterValue) != -1) {
                            // Select the filter
                            $filterButton.addClass('is-checked');

                            // Since a filter is checked, uncheck the "Show All"
                            $filterShowAllButton.removeClass('is-checked');
                        }
                    });
                });

                $filterSelects.filter('[data-filter-type="'+filterType+'"]').each(function() {
                    $(this).find('option').each(function () {
                        var filterValue = this.value;

                        // Select the filter
                        $(this).prop('selected', (filterValues.indexOf(filterValue) != -1));

                        // Since a filter is checked, uncheck the "Show All"
                        $filterShowAllButton.removeClass('is-checked');
                    });
                });
            }
        });

        // Initialize Sorting
        var sortDirection = 'ASC';
        var sortValue     = null;
        var sortHashValue = getHashValue('sort');

        if (sortHashValue) {
            var sortState = sortHashValue.split(':');

            sortValue      = sortState[0];
            sortDirection  = (sortState[1] == 'DESC') ? 'DESC' : 'ASC';
        }


        /**
         * Update the Filter State
         */
        var updateFilterState = function() {
            // Reset Active Filter State
            activeFilters  = {};

            // Find Active Filters (from buttons)
            $filterButtons.filter('[data-filter!="\*"]').each(function() {
                var $filterData    = $(this).data('filter');
                var filterIsActive = $(this).hasClass('is-checked');

                $.each($filterData, function(filterType, filterValue) {
                    activeFilters[filterType] = activeFilters[filterType] || [];
                    if (filterIsActive) activeFilters[filterType].push(filterValue);
                });
            });

            // Find Active Filters (from selects)
            $filterSelects.each(function() {
                var filterType     = $(this).data('filter-type');
                var filterValue    = this.value;
                var filterIsActive = (filterValue != '*');

                activeFilters[filterType] = activeFilters[filterType] || [];
                if (filterIsActive) {
                    activeFilters[filterType].push(filterValue);
                }
            });

            // Set the URL Hash to the current filter state
            $.each(activeFilters, function(filterType, filterValue) {
                setHashValue(filterType, filterValue.join(':'));
            });

            // Count how many Filters are active
            activeFilterCount = _.reduce(activeFilters, function(total, val) {
                return total + (val.length != 0); // Count number of non-empty arrays in the activeFilters object
            }, 0);

            // If no filters are active, mark the "show all" button as active
            if (activeFilterCount == 0) {
                $filterButtons.filter('[data-filter="\*"]').addClass('is-checked');
            }

            // Apply the Filter(s)
            $isotope.arrange({ filter: filterFunction });

            // Adding empty message
            $(emptyText).removeClass('active');
            // Wait 1 second for the animation.
            setTimeout( function() {
                ($(gridBlock).length == 0) ? $(emptyText).addClass('active') : $(emptyText).removeClass('active');
            }, 1000);
        };




        // Initialize Isotope Object
        $isotope = new Isotope(grid, dataOptions);

        // Apply the initial state filters
        updateFilterState();


        // Expose Isotope Redraw Event to Window
        $(window).on('isotope-redraw', function() {
            $isotope.layout();
        });


        // Bind control for "Sort" elements
        $sorting.on('change', function(e) {
            sortValue     = $(this).find(':selected').val();

            // Set the URL Hash to the current sort state
            setHashValue('sort', sortValue+':'+sortDirection);

            $isotope.arrange({
                sortBy: sortValue,
                sortAscending: (sortDirection != 'DESC')
            });
        });


        // Bind control for "Filter" elements (with buttons)
        $filterButtons.on('click', function(e) {
            var $this          = $(e.target);
            var filterValue    = $this.data('filter');
            var activeFilters  = {};

            // "Show All" cannot be unchecked, clicking it always enables it and disables everything else
            if (filterValue === '*') {
                // Deselect any filters (from buttons)
                $filterButtons.filter('.is-checked').removeClass('is-checked');

                // Deselect any filters (from selects)
                $filterSelects.find('option').prop('selected', false);

                // Select the "Show All" (button)
                $this.addClass('is-checked');

                // Select the "Show All" state (for selects)
                $filterSelects.find('option[value="\*"]').prop('selected', true);
            }

            // If clicking an item that is already selected
            else if ($this.hasClass('is-checked')) {
                $this.removeClass('is-checked');

                // If nothing is remaining, check off "Show All"
                if ($filterButtons.filter('.is-checked').length == 0) {
                    $filterButtons.filter('[data-filter="\*"]').addClass('is-checked');
                }
            }

            // If selecting a new item, disable "Show All" and select the desired filter
            else {
                $filterButtons.filter('[data-filter="\*"]').removeClass('is-checked');
                $this.addClass('is-checked');
            }

            // Notify Dropdowns of the change (e.g. to reset to "show all")
            $(selectbox_selector).change();

            // Update the Filtered State
            updateFilterState();
        });


        // Bind control for "Filter" elements (with selects)
        $filterSelects.on('change', function() {
            var $this          = $(this);
            var filterType     = $this.data('data-filter-type');
            var filterValue    = this.value;
            var activeFilters  = {};

            // If selecting a new item, disable "Show All"
            if (filterValue != '*') {
                $filterButtons.filter('[data-filter="\*"]').removeClass('is-checked');
            }

            // Update the Filtered State
            updateFilterState();
        });
    });



    // Initialize Custom Dropdowns
    $(selectbox_selector).each(function(index, el) {

        $(this).find('option').each(function(i, element) {

            // Initialize placeholder with 1st dropdown value
            (i === 0 ) ? $(this).closest(select_wrapper).next().find(label).html($(this).text()) : '';

            if ($(this).is(':selected')) {
                $(this).closest(select_wrapper).next().find(selectbox_options).append('<li index="' + $(this).val() + '" class="selected">'+$(this).text()+'</li>');

                // Replace placeholder with the selected item
                $(this).closest(select_wrapper).next().find(label).html($(this).text());
            } else if ($(this).is(':disabled')) {
                $(this).closest(select_wrapper).next().find(selectbox_options).append('<li index="' + $(this).val() + '" class="disabled">'+$(this).text()+'</li>');
            } else  {
                $(this).closest(select_wrapper).next().find(selectbox_options).append('<li index="' + $(this).val() + '" class="">'+$(this).text()+'</li>');
            }

        });
    });

    // Enable popup on click
    $(label).on('click', function(e) {
        e.stopPropagation();
        $(selectbox_options).removeClass('active');
        $(e.currentTarget).siblings('ul').addClass('active');
    });
    // Remove popup on click elsewhere
    $(body).on('click', function(e) {
        $(selectbox_options).removeClass('active');
    });

    // Make selection and update mobile picker
    $(selectbox_options+' li').on('click', function(e) {

        // Define current element
        var currentElement = $(e.currentTarget).parent().attr('class').replace('active', '');
        var currentSelect  = $(e.currentTarget).parent().parent().prev().find('select');

        // Make selection
        if ($(e.currentTarget).attr('class') === 'selected') {
            $($(e.currentTarget).siblings()).each(function(e) {
                $(this).not('.disabled').not('.selected').attr('class', '');
            });
            $(currentSelect).find('option[value="'+ $(this).attr('index') +'"]').prop('selected', false);
        } else {
            $($(e.currentTarget).siblings()).each(function() {
                $(this).not('.disabled').attr('class', '');
            });
            $(e.currentTarget).attr('class', 'selected');
            $(currentSelect).find('option[value="'+ $(this).attr('index') +'"]').prop('selected', true);

            // Update desktop placeholder
            $(e.currentTarget).parent().next().html($(this).html());

            // Bind to native select
            $(currentSelect).change();
        }

    });


    $(selectbox_selector).on('change', function(e) {
        // Update desktop picker
        $(this).parents(select_set).find('li').not('.disabled').attr('class', '');
        $(this).parents(select_set).find('li[index="'+$(this).find(':selected').val()+'"]').attr('class', 'selected');
        $(this).parents(select_set).find(label).html($(this).find(':selected').text());
    });
};



/**
 * Universal Sort Function
 * Loops through element data and comapres it against the selected filters
 */
var sortFunction = function(sortProperty, itemElem) {
    var elementData      = $(itemElem).data('item-data');

    if (elementData.hasOwnProperty(sortProperty)) {
        return elementData[sortProperty];
    }
    else {
        console.log('Unexpected sort property [' + sortProperty + ']');

        return 1;
    }
};



/**
 * Universal Filter Function
 * Loops through element data and comapres it against the selected filters
 */
var filterFunction = function() {
    var elementData  = $(this).data('item-data');
    var show_item    = true;

    // Scan the filters for a match in the element data
    $.each(activeFilters, function(filterType, filterValues) {

        // Filter is in a "show all" state
        if (filterValues.length == 0) {
            // Still a candidate to be shown
        }

        // If the filter type exists for this element, compare it against the value
        else if (filterType in elementData) {

            // Loop through the active filter values to see if it's a match
            $.each(filterValues, function(filterIndex, filterValue) {
                // If filter value is an exact match, include the item
                if (elementData[filterType] === filterValue) {
                    // Still a candidate to be shown
                }

                // If the filter value is contained in an array of elements, include the item
                else if (
                    Object.prototype.toString.call(elementData[filterType]) === '[object Array]' &&
                    _.includes(elementData[filterType], filterValue)
                ) {
                    // Still a candidate to be shown
                }

                // Filter did not match; hide the item
                else {
                    show_item = false;
                }
            });

        }

        // Element doesn't have data for this filter, but the filter is active; hide the item
        else {
            show_item = false;
        }

        // Nothing else to do, if we've already decided to hide this
        if (!show_item) return;
    });


    // Return the desired "show" state
    return show_item;
};


/**
 * jQuery "unparam" method
 * Reverses the native jQuery "param" method (converts a query string into an object)
 *
 * e.g. propX=1&propY=2
 *      => { propX: 1, propY: 2 }
 *
 * Source: https://gist.github.com/nuysoft/7907613
 */
(function() {
    $.extend({
        unparam: function(param) {
            if (param[0] === '?') param = param.slice(1);
            var re = {};

            for (var i = 0, arr = param.split('&'), kv; kv = arr[i]; i++) {
                kv = kv.split('=');
                re[kv[0]] = decodeURIComponent(kv[1]);
            }

            return re;
        }
    });

})();


/**
 * Parse URL Hash
 * e.g. example.com#propX=1&propY=2
 *      => { propX: 1, propY: 2 }
 */
var parseHash = function() {
    // Remove the first character (i.e. the prepended "#").
    var hash = location.hash.replace(/^.*?#/, '');

    return $.unparam(hash);
};


/**
 * Get Hash Value
 * e.g. example.com#propX=1&propY=2
 *      var val = getHashValue('propX'); // = 1
 */
var getHashValue = function(property) {
    var hashObj = parseHash();

    return hashObj[property];
};


/**
 * Set Hash Value
 * e.g. // Before: example.com#propX=1&propY=2
 *      setHashValue('propY', 3);
 *      // After:  example.com#propX=1&propY=3
 */
var setHashValue = function(property, value) {
    var hashObj = parseHash();

    hashObj[property] = value;

    location.hash = $.param(hashObj);
};
